// DOCUMENT TYPE
export const GET_DOCUMENT_TYPES = '/document_type/query';
export const GET_DOCUMENT_TYPE = '/document_type/';
export const POST_DOCUMENT_TYPE = '/document_type/';
export const PUT_DOCUMENT_TYPE = '/document_type/';
export const DELETE_DOCUMENT_TYPE = '/document_type/';
export const CHECK_DOCUMENT_TYPE_EXISTS = '/document_type/query';
